import { render, staticRenderFns } from "./SchemaFilter.vue?vue&type=template&id=3ff40933"
import script from "./SchemaFilter.vue?vue&type=script&lang=js"
export * from "./SchemaFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports